var UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export var isValidUUID = function isValidUUID(value) {
  return UUID_V4_REGEX.test(value);
};